import { createSlice } from '@reduxjs/toolkit';

export const partnerSlice = createSlice({
    name: 'partner',
    initialState: {
        userToAction: { id: '', name: '', surnames: '', email: '', address: '', city: '', taxCode: '', phone: '', additionalPhone: '', zipCode: '', swift: '', iban: '', cc: '', role: '', dni: '', typeDni: '' , registrationDate: '', club: 'España', language: '', urlDocuments: null }
    },
    reducers: {
        selectPartner: (state, {payload}) => {
            state.userToAction = payload;
        },
        unSelectPartner: (state) => {
            state.userToAction = {
                userToAction: { id: '', name: '', surnames: '', email: '', address: '', city: '', taxCode: '', phone: '', additionalPhone: '', zipCode: '', swift: '', iban: '', cc: '', role: '', dni: '', typeDni: '' , registrationDate: '', club: 'España', language: '' }
            }
        }
    }
});

export const { selectPartner, unSelectPartner } = partnerSlice.actions;